<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-添加
    -->
  <el-dialog title="预警报警" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="params" :rules="formRules" ref="params">

      <el-form-item label="技师名称:" prop="" :label-width="formLabelWidth">
        <div>{{form.waiter?form.waiter.username:'暂无'}}</div>
      </el-form-item>
      <!-- <el-form-item label="技师头像：" prop="image" :label-width="formLabelWidth">
        <el-row>
          <div v-if="imageId!=''" class="img">
            <img :src="form.image" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item> -->
      <el-form-item label="电  话：" :label-width="formLabelWidth">
        <div style="color:red">{{form.waiter?form.waiter.mobile:'暂无'}}</div>
      </el-form-item>
      <el-form-item label="报警位置:" prop="" :label-width="formLabelWidth">
        <div style="color:green">{{form.service_address}}</div>
      </el-form-item>
      <el-form-item label="报警类型:" prop="" :label-width="formLabelWidth">
        <div>{{form.type.text}}</div>
      </el-form-item>
      <el-form-item label="报警时间：" prop="" :label-width="formLabelWidth">
        <div>{{form.createTime}}</div>
      </el-form-item>
      <!-- <el-form-item label="处理人：" :rules="[{ required: true, message: '选择处理状态' }]" prop="deal_user" :label-width="formLabelWidth">
        <el-input v-model="params.deal_user"></el-input>
      </el-form-item> -->
      <el-form-item :label-width="formLabelWidth" label="处理状态：" :rules="[{ required: true, message: '选择处理状态' }]" prop="is_deal">
        <el-radio-group v-model="params.is_deal">
          <el-radio :label="1">已处理</el-radio>
          <el-radio :label="0">未处理</el-radio>
          <el-radio :label="2">已撤销</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label-width="formLabelWidth" label="备注：">
        <el-input type="textarea" min="0" v-model="params.word" class="mb16 max-w460" placeholder="请输入备注">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>

</template>

<script>
import CallmsgApi from "@/api/callmsg.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      form: {},
      formRules: {
        is_deal: [
          {
            required: true,
            message: "请选择状态",
            trigger: "blur"
          }
        ]
      },
      params: {
        deal_user: "",
        id: "",
        word: "",
        is_deal: 1
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false
    };
  },
  props: ["open_add", "addform"],
  created() {
    this.dialogVisible = this.open_add;
    this.form = this.addform;
    this.params.is_deal = this.addform.is_deal ? this.addform.is_deal.value : 0;
    this.params.id = this.addform.id;
  },
  methods: {
    /*添加用户*/
    addUser() {
      let self = this;
      self.$refs.params.validate(valid => {
        if (valid) {
          self.loading = true;
          CallmsgApi.calldeal(self.params)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "审阅成功",
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.image = e[0].filePath;
        this.imageId = e[0].fileId;
      }
      this.isupload = false;
    }
  }
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/callmsg/Add.vue